$('.ongoing-development-skeleton-content-element').on("click", function() {
    $(this).toggleClass('bg-dark text-light');
});